export const AssignmentsScreenPath =
  "/closers/check-closers-availability/assignments";
